import React from 'react'
import DiscountVersionPicker from './discount-versions-picker'
import {
  CurrencyDollarIcon,
  CalendarIcon,
  Cog6ToothIcon,
  AdjustmentsVerticalIcon
} from "@heroicons/react/20/solid";

import { toTitleCase } from "../../../../lib/string";
import { formatDate } from "../../../../lib/datetime";

export default function Header({ discount, versions }) {
  return (
    <header className="bg-white shadow">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-6 pb-3">
        <h2 className="text-lg tracking-tight text-gray-400">Discount Policy</h2>
        <h1 className="text-3xl font-bold tracking-tight text-gray-900">{discount.carrier.name}</h1>
        <div className="mt-1 flex items-center justify-between sm:mt-0">
          {/* Left side details */}
          <div className="mt-1 flex flex-wrap space-x-6 sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
            <DiscountVersionPicker discount={discount} versions={versions} />
            <div className="mt-2 flex items-center text-sm text-gray-500">
              <CurrencyDollarIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
              { discount.state_taxes_enabled == true ? "Taxes Included" : "No State Taxes" }
            </div>
            <div className="mt-2 flex items-center text-sm text-gray-500">
              <Cog6ToothIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
              { toTitleCase(discount.state) }
            </div>
            <div className="mt-2 flex items-center text-sm text-gray-500">
              <AdjustmentsVerticalIcon aria-hidden="true" className="mr-1.5 size-5 shrink-0 text-gray-400" />
              { toTitleCase(discount.mode) }
            </div>
          </div>
          {/* Right side Edit button */}
          <a
            className="ml-4 inline-flex items-center rounded-md bg-teal-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
            href={`/discounts/${discount.id}/edit`}
          >
            Edit
          </a>
        </div>
      </div>
    </header>
  )
}
